var _toConsumableArray = require("/usr/src/app/www/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/usr/src/app/www/app/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/usr/src/app/www/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schemaOffer = exports.schemaPerson = exports.schemaStore = exports.schemaArticle = exports.schemaBlog = exports.schemaProduct = exports.schemaSearch = exports.schemaWebSite = exports.schemaBreadcrumbs = exports.schemaListItem = exports.schemaImage = exports.schemaAddress = exports.schemaOrg = exports.schemaData = exports.schemaTemplate = exports.schemaDocument = exports.schemaContent = void 0;

var utils_1 = require("./utils");

var schemaTypes = function schemaTypes(data, mapping) {
  return Object.keys(mapping).find(function (key) {
    return data === null || data === void 0 ? void 0 : data.hasOwnProperty(key);
  }) || "";
};

var schemaContent = function schemaContent(metadata) {
  return (metadata === null || metadata === void 0 ? void 0 : metadata.schema) && (metadata === null || metadata === void 0 ? void 0 : metadata.schema(metadata)) || (0, exports.schemaWebSite)(metadata);
};

exports.schemaContent = schemaContent;

var schemaDocument = function schemaDocument(data, mapping) {
  return (data === null || data === void 0 ? void 0 : data.hasOwnProperty(schemaTypes(data, mapping))) ? data[schemaTypes(data, mapping)] : {};
};

exports.schemaDocument = schemaDocument;

var schemaTemplate = function schemaTemplate() {
  var template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var templateMapping = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _a;

  var mapping = templateMapping || {
    title: (item === null || item === void 0 ? void 0 : item.title) || "",
    description: ((_a = item === null || item === void 0 ? void 0 : item.description) === null || _a === void 0 ? void 0 : _a.split(".")[0]) || ""
  };
  var regex = new RegExp(Object.keys(mapping).map(function (key) {
    return "{".concat(key, "}");
  }).join("|"), "gi");
  return template ? Object.entries(template).reduce(function (obj, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return Object.assign(Object.assign({}, obj), _defineProperty({}, key, value.replace(regex, function (item) {
      return mapping[item.replace(/[{}]/g, "")];
    })));
  }, {}) : null;
};

exports.schemaTemplate = schemaTemplate;

var schemaData = function schemaData(_ref3, mapping) {
  var breadcrumbs = _ref3.breadcrumbs,
      data = _ref3.data,
      global = _ref3.global,
      language = _ref3.language,
      _ref3$organisation = _ref3.organisation,
      organisation = _ref3$organisation === void 0 ? null : _ref3$organisation,
      _ref3$preferences = _ref3.preferences,
      preferences = _ref3$preferences === void 0 ? null : _ref3$preferences,
      routes = _ref3.routes,
      social = _ref3.social,
      _ref3$template = _ref3.template,
      template = _ref3$template === void 0 ? null : _ref3$template,
      _ref3$templateMapping = _ref3.templateMapping,
      templateMapping = _ref3$templateMapping === void 0 ? null : _ref3$templateMapping,
      tracking = _ref3.tracking,
      url = _ref3.url;

  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;

  var mappedDocument = (0, exports.schemaDocument)(data, mapping);
  var document = Object.assign(Object.assign({}, mappedDocument), ((_a = mappedDocument === null || mappedDocument === void 0 ? void 0 : mappedDocument.shopify) === null || _a === void 0 ? void 0 : _a.raw) && Object.assign({}, JSON.parse((_b = mappedDocument === null || mappedDocument === void 0 ? void 0 : mappedDocument.shopify) === null || _b === void 0 ? void 0 : _b.raw)));
  var templated = (0, exports.schemaTemplate)(template, document, templateMapping);
  var schema = mapping[schemaTypes(data, mapping)] || false;
  var type = schemaTypes(data, mapping) || "website";
  var sanityMeta = (document === null || document === void 0 ? void 0 : document.metadata) || ((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.content) === null || _c === void 0 ? void 0 : _c.edges[0]) === null || _d === void 0 ? void 0 : _d.node) === null || _e === void 0 ? void 0 : _e.metadata) || {};
  var shopifyMeta = (document === null || document === void 0 ? void 0 : document.shopify) || ((_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.content) === null || _f === void 0 ? void 0 : _f.edges[0]) === null || _g === void 0 ? void 0 : _g.node) === null || _h === void 0 ? void 0 : _h.shopify) || {};
  var meta = Object.assign(Object.assign({}, sanityMeta), {
    title: (sanityMeta === null || sanityMeta === void 0 ? void 0 : sanityMeta.title) || (shopifyMeta === null || shopifyMeta === void 0 ? void 0 : shopifyMeta.seoTitle),
    description: (sanityMeta === null || sanityMeta === void 0 ? void 0 : sanityMeta.description) || (shopifyMeta === null || shopifyMeta === void 0 ? void 0 : shopifyMeta.seoDescription)
  });
  var org = organisation || preferences;
  var separator = (org === null || org === void 0 ? void 0 : org.separator) || "|";
  var metaLang = language || "en_AU";
  var siteName = (org === null || org === void 0 ? void 0 : org.title) || "";
  var siteDescription = (org === null || org === void 0 ? void 0 : org.description) || "";
  var siteURL = (org === null || org === void 0 ? void 0 : org.url) || "";
  var pageTitle = (meta === null || meta === void 0 ? void 0 : meta.title) || (templated === null || templated === void 0 ? void 0 : templated.title) || (document === null || document === void 0 ? void 0 : document.title) || (global === null || global === void 0 ? void 0 : global.title);
  var title = pageTitle !== siteName && pageTitle && siteName ? "".concat(pageTitle, " ").concat(separator, " ").concat(siteName) : siteName || "";
  var description = (meta === null || meta === void 0 ? void 0 : meta.description) || (templated === null || templated === void 0 ? void 0 : templated.description) || (document === null || document === void 0 ? void 0 : document.description) || (global === null || global === void 0 ? void 0 : global.description) || siteDescription || "";
  var pageUrl = "".concat(siteURL).concat(url) || "";
  var author = (org === null || org === void 0 ? void 0 : org.author) || "";
  var robots = (meta === null || meta === void 0 ? void 0 : meta.noIndex) ? "noindex, nofollow" : "all";
  var canonical = (meta === null || meta === void 0 ? void 0 : meta.canonicalUrl) ? "".concat(siteURL).concat(meta === null || meta === void 0 ? void 0 : meta.canonicalUrl) : pageUrl;
  var facebookAppID = (tracking === null || tracking === void 0 ? void 0 : tracking.facebookAppId) || "";
  var googleSiteVerify = (tracking === null || tracking === void 0 ? void 0 : tracking.googleSiteVerify) || "";
  var searchURL = "".concat(siteURL).concat((routes === null || routes === void 0 ? void 0 : routes.SEARCH) || "/");
  var socialProfiles = ((_j = social === null || social === void 0 ? void 0 : social.channels) === null || _j === void 0 ? void 0 : _j.map(function (channel) {
    return channel === null || channel === void 0 ? void 0 : channel.url;
  })) || [];
  var twitterUser = ((_k = social === null || social === void 0 ? void 0 : social.channels) === null || _k === void 0 ? void 0 : _k.filter(function (channel) {
    var _a;

    return (_a = channel === null || channel === void 0 ? void 0 : channel.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("twitter");
  }).map(function (channel) {
    return channel === null || channel === void 0 ? void 0 : channel.url.replace("https://twitter.com/", "");
  })) || "";
  var siteImage = (0, exports.schemaImage)({
    alt: "".concat(siteName),
    url: "".concat((_m = (_l = org === null || org === void 0 ? void 0 : org.logo) === null || _l === void 0 ? void 0 : _l.asset) === null || _m === void 0 ? void 0 : _m.url)
  });
  var address = (0, exports.schemaAddress)(Object.assign({}, organisation));
  var image = (0, exports.schemaImage)({
    alt: "".concat(title),
    url: "".concat(((_p = (_o = meta === null || meta === void 0 ? void 0 : meta.image) === null || _o === void 0 ? void 0 : _o.asset) === null || _p === void 0 ? void 0 : _p.url) || ((_r = (_q = org === null || org === void 0 ? void 0 : org.logo) === null || _q === void 0 ? void 0 : _q.asset) === null || _r === void 0 ? void 0 : _r.url))
  });
  var listItems = [(0, exports.schemaListItem)({
    name: "Homepage",
    url: siteURL,
    position: 1
  })].concat(_toConsumableArray((breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) ? breadcrumbs.map(function (_ref4) {
    var name = _ref4.name,
        position = _ref4.position,
        url = _ref4.url;
    return listItems.push((0, exports.schemaListItem)({
      name: name,
      url: "".concat(siteURL).concat(url),
      position: position || listItems.length + 1
    }));
  }) : []));
  listItems.push((0, exports.schemaListItem)({
    name: title,
    url: pageUrl,
    position: listItems.length + 1
  }));
  return {
    schema: schema,
    document: document,
    type: type,
    metaLang: metaLang,
    siteName: siteName,
    siteURL: siteURL,
    title: title,
    description: description,
    pageUrl: pageUrl,
    author: author,
    robots: robots,
    canonical: canonical,
    facebookAppID: facebookAppID,
    googleSiteVerify: googleSiteVerify,
    socialProfiles: socialProfiles,
    twitterUser: twitterUser,
    siteImage: siteImage,
    image: image,
    address: address,
    searchURL: searchURL,
    listItems: listItems
  };
};

exports.schemaData = schemaData;

var schemaOrg = function schemaOrg(_ref5) {
  var _ref5$address = _ref5.address,
      address = _ref5$address === void 0 ? {} : _ref5$address,
      siteName = _ref5.siteName,
      siteImage = _ref5.siteImage,
      siteURL = _ref5.siteURL,
      socialProfiles = _ref5.socialProfiles;
  return {
    "@context": "http://schema.org",
    "@type": "Organization",
    url: siteURL,
    name: siteName,
    address: address,
    logo: siteImage,
    sameAs: socialProfiles
  };
};

exports.schemaOrg = schemaOrg;

var schemaAddress = function schemaAddress(_ref6) {
  var addressLocality = _ref6.addressLocality,
      addressRegion = _ref6.addressRegion,
      postalCode = _ref6.postalCode,
      streetAddress = _ref6.streetAddress;
  return {
    "@type": "PostalAddress",
    addressLocality: addressLocality || "",
    addressRegion: addressRegion || "",
    postalCode: postalCode || "",
    streetAddress: streetAddress || ""
  };
};

exports.schemaAddress = schemaAddress;

var schemaImage = function schemaImage(image) {
  return {
    "@type": "ImageObject",
    description: image.alt || "",
    url: image.url || ""
  };
};

exports.schemaImage = schemaImage;

var schemaListItem = function schemaListItem(_ref7) {
  var url = _ref7.url,
      name = _ref7.name,
      position = _ref7.position;
  return {
    "@type": "ListItem",
    item: {
      "@id": url,
      name: name
    },
    position: position
  };
};

exports.schemaListItem = schemaListItem;

var schemaBreadcrumbs = function schemaBreadcrumbs(_ref8) {
  var listItems = _ref8.listItems;
  return {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    description: "Breadcrumbs list",
    name: "Breadcrumbs",
    itemListElement: listItems
  };
};

exports.schemaBreadcrumbs = schemaBreadcrumbs;

var schemaWebSite = function schemaWebSite(_ref9) {
  var title = _ref9.title,
      description = _ref9.description,
      metaLang = _ref9.metaLang,
      author = _ref9.author,
      url = _ref9.url,
      siteURL = _ref9.siteURL,
      searchURL = _ref9.searchURL;
  return {
    "@context": "http://schema.org",
    "@type": "WebPage",
    url: url,
    inLanguage: metaLang,
    mainEntityOfPage: siteURL,
    description: description,
    name: title,
    author: (0, exports.schemaPerson)({
      name: author
    }),
    creator: (0, exports.schemaPerson)({
      name: author
    }),
    publisher: (0, exports.schemaPerson)({
      name: author
    }),
    copyrightYear: new Date().getFullYear(),
    copyrightHolder: (0, exports.schemaPerson)({
      name: author
    }),
    potentialAction: {
      "@type": "SearchAction",
      target: "".concat(searchURL, "?q={query}"),
      "query-input": "required name=query"
    }
  };
};

exports.schemaWebSite = schemaWebSite;

var schemaSearch = function schemaSearch(_ref10) {
  var title = _ref10.title,
      url = _ref10.url,
      searchURL = _ref10.searchURL,
      document = _ref10.document;

  var _a;

  return {
    "@context": "http://schema.org",
    "@type": "WebPage",
    url: url,
    name: title,
    potentialAction: {
      "@type": "SearchAction",
      target: "".concat(searchURL, "?q={query}"),
      "query-input": "required name=query",
      agent: (0, exports.schemaPerson)({
        name: ((_a = document === null || document === void 0 ? void 0 : document.authUser) === null || _a === void 0 ? void 0 : _a.firstname) || "Guest"
      }),
      query: (document === null || document === void 0 ? void 0 : document.query) || ""
    }
  };
};

exports.schemaSearch = schemaSearch;

var schemaProduct = function schemaProduct(_ref11) {
  var title = _ref11.title,
      description = _ref11.description,
      url = _ref11.url,
      image = _ref11.image,
      siteURL = _ref11.siteURL,
      document = _ref11.document;

  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  return {
    "@context": "http://schema.org",
    "@type": "Product",
    name: title,
    url: url,
    description: description,
    gtin13: (_a = (0, utils_1.decodeBase64)(document === null || document === void 0 ? void 0 : document.id)) === null || _a === void 0 ? void 0 : _a.replace("gid://shopify/Product/", ""),
    image: image,
    brand: {
      "@type": "Thing",
      name: document === null || document === void 0 ? void 0 : document.vendor
    },
    sku: (document === null || document === void 0 ? void 0 : document.variants) && (document === null || document === void 0 ? void 0 : document.variants.length) ? document === null || document === void 0 ? void 0 : document.variants[0].sku : "",
    offers: {
      "@type": "AggregateOffer",
      highPrice: ((_c = (_b = document === null || document === void 0 ? void 0 : document.priceRange) === null || _b === void 0 ? void 0 : _b.maxVariantPrice) === null || _c === void 0 ? void 0 : _c.amount) || "",
      lowPrice: ((_e = (_d = document === null || document === void 0 ? void 0 : document.priceRange) === null || _d === void 0 ? void 0 : _d.minVariantPrice) === null || _e === void 0 ? void 0 : _e.amount) || "",
      priceCurrency: ((_g = (_f = document === null || document === void 0 ? void 0 : document.priceRange) === null || _f === void 0 ? void 0 : _f.maxVariantPrice) === null || _g === void 0 ? void 0 : _g.currencyCode) || "",
      offerCount: (_h = document === null || document === void 0 ? void 0 : document.variants) === null || _h === void 0 ? void 0 : _h.length,
      offers: (document === null || document === void 0 ? void 0 : document.variants) ? (_j = document === null || document === void 0 ? void 0 : document.variants) === null || _j === void 0 ? void 0 : _j.map(function (variant) {
        return (0, exports.schemaOffer)({
          siteURL: siteURL,
          variant: Object.assign({}, variant),
          handle: document.handle
        });
      }) : []
    },
    keywords: []
  };
};

exports.schemaProduct = schemaProduct;

var schemaBlog = function schemaBlog(_ref12) {
  var title = _ref12.title,
      url = _ref12.url,
      siteName = _ref12.siteName,
      siteImage = _ref12.siteImage,
      siteURL = _ref12.siteURL,
      socialProfiles = _ref12.socialProfiles;
  return {
    "@context": "http://schema.org",
    "@type": "Blog",
    name: title,
    url: url,
    publisher: (0, exports.schemaOrg)({
      siteName: siteName,
      siteImage: siteImage,
      siteURL: siteURL,
      socialProfiles: socialProfiles
    }),
    keywords: []
  };
};

exports.schemaBlog = schemaBlog;

var schemaArticle = function schemaArticle(_ref13) {
  var title = _ref13.title,
      description = _ref13.description,
      metaLang = _ref13.metaLang,
      author = _ref13.author,
      url = _ref13.url,
      image = _ref13.image,
      siteName = _ref13.siteName,
      siteImage = _ref13.siteImage,
      siteURL = _ref13.siteURL,
      socialProfiles = _ref13.socialProfiles,
      document = _ref13.document;

  var _a, _b, _c, _d, _e, _f;

  return {
    "@context": "http://schema.org",
    "@type": "Article",
    articleBody: description,
    author: (0, exports.schemaPerson)({
      name: ((_b = (_a = document === null || document === void 0 ? void 0 : document.attributes) === null || _a === void 0 ? void 0 : _a.author) === null || _b === void 0 ? void 0 : _b.name) || author
    }),
    copyrightHolder: (0, exports.schemaPerson)({
      name: ((_d = (_c = document === null || document === void 0 ? void 0 : document.attributes) === null || _c === void 0 ? void 0 : _c.author) === null || _d === void 0 ? void 0 : _d.name) || author
    }),
    copyrightYear: (document === null || document === void 0 ? void 0 : document._createdAt) ? document === null || document === void 0 ? void 0 : document._createdAt.split("-")[0] : "",
    creator: (0, exports.schemaPerson)({
      name: ((_f = (_e = document === null || document === void 0 ? void 0 : document.attributes) === null || _e === void 0 ? void 0 : _e.author) === null || _f === void 0 ? void 0 : _f.name) || author
    }),
    dateModified: (document === null || document === void 0 ? void 0 : document._createdAt) || "",
    datePublished: (document === null || document === void 0 ? void 0 : document._createdAt) || "",
    description: description,
    headline: title,
    image: image,
    inLanguage: metaLang,
    publisher: (0, exports.schemaOrg)({
      siteName: siteName,
      siteImage: siteImage,
      siteURL: siteURL,
      socialProfiles: socialProfiles
    }),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": siteURL
    },
    name: title,
    url: url
  };
};

exports.schemaArticle = schemaArticle;

var schemaStore = function schemaStore(_ref14) {
  var title = _ref14.title,
      description = _ref14.description,
      image = _ref14.image,
      author = _ref14.author,
      url = _ref14.url,
      document = _ref14.document;

  var _a, _b;

  return {
    "@context": "http://www.schema.org",
    "@type": "Store",
    address: (document === null || document === void 0 ? void 0 : document.address) || "",
    brand: {
      "@type": "Brand",
      name: author
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: (_a = document === null || document === void 0 ? void 0 : document.location) === null || _a === void 0 ? void 0 : _a.lat,
      longitude: (_b = document === null || document === void 0 ? void 0 : document.location) === null || _b === void 0 ? void 0 : _b.lng
    },
    description: description,
    email: (document === null || document === void 0 ? void 0 : document.email) || "",
    image: image,
    name: title,
    telephone: (document === null || document === void 0 ? void 0 : document.phone) || "",
    url: url
  };
};

exports.schemaStore = schemaStore;

var schemaPerson = function schemaPerson(_ref15) {
  var name = _ref15.name;
  return {
    "@type": "Person",
    name: name || ""
  };
};

exports.schemaPerson = schemaPerson;

var schemaOffer = function schemaOffer(_ref16) {
  var siteURL = _ref16.siteURL,
      variant = _ref16.variant,
      handle = _ref16.handle;

  var _a, _b, _c;

  return {
    "@type": "Offer",
    availability: "http://schema.org/".concat((variant === null || variant === void 0 ? void 0 : variant.availableForSale) ? "InStock" : "OutOfStock"),
    price: ((_a = variant === null || variant === void 0 ? void 0 : variant.priceV2) === null || _a === void 0 ? void 0 : _a.amount) || "",
    priceCurrency: ((_b = variant === null || variant === void 0 ? void 0 : variant.priceV2) === null || _b === void 0 ? void 0 : _b.currencyCode) || "",
    sku: variant === null || variant === void 0 ? void 0 : variant.sku,
    url: "".concat(siteURL, "/products/").concat(handle, "?variant=").concat((_c = (0, utils_1.decodeBase64)(variant === null || variant === void 0 ? void 0 : variant.id)) === null || _c === void 0 ? void 0 : _c.replace("gid://shopify/ProductVariant/", ""))
  };
};

exports.schemaOffer = schemaOffer;